import { combineReducers } from '@ngrx/store';

import {
  isLoadingAutocompletePlacesReducer as isLoadingAutocompletePlaces
} from '@shared/base-search-bar/store/reducers/ui/is-loading-autocomplete-places.reducer';
import {
  placeTypeSelectedReducer as placeTypeSelected
} from '@shared/base-search-bar/store/reducers/ui/place-type-selected.reducer';
import {
  isSearchAirportForIpReducer as isSearchAirportForIp
} from '@shared/base-search-bar/store/reducers/ui/is-search-airport-ip.reducer';
import {
  isSearchTerminalForIpReducer as isSearchTerminalForIp
} from '@shared/base-search-bar/store/reducers/ui/is-search-terminal-ip.reducer';
import {
  isHeaderEditButtonVisibleReducer as isHeaderEditButtonVisible
} from '@shared/base-search-bar/store/reducers/ui/is-header-edit-button-visible.reducer';
import {
  autoDiffPlaceReducer as autoDiffPlace
} from '@shared/base-search-bar/store/reducers/ui/auto-diff-place.reducer';
import {
  skipServicesReducer as skipServices
} from '@shared/base-search-bar/store/reducers/ui/skip-services.reducer';
import {
  tabSelectedHomeReducer as tabSelectedHome
} from '@shared/base-search-bar/store/reducers/ui/tab-selected-home.reducer';
import { editSearchReducer as editSearch } from '@shared/base-search-bar/store/reducers/ui/edit-search.reducer';


export const ui = combineReducers({
  isLoadingAutocompletePlaces,
  placeTypeSelected,
  isSearchAirportForIp,
  isSearchTerminalForIp,
  isHeaderEditButtonVisible,
  autoDiffPlace,
  skipServices,
  tabSelectedHome,
  editSearch,
});
